import React, {useState} from "react"
import {useLanguages} from "../../hooks/useLanguageData"
import {useLanguage} from "../../context/LanguageContext"
import {Button, Menu, MenuItem} from "@mui/material"
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"

const LanguageSelector = () => {
  const {languages, loading, error} = useLanguages()
  const {language, changeLanguage} = useLanguage()

  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode)
    handleClose()
  }

  if (loading) {
    return <div>Loading...</div>
  }

  if (error) {
    return <div>Error: {error}</div>
  }

  const flagImages = {
    RU: require("../../assets/lang/ru.png"),
    TR: require("../../assets/lang/tr.png"),
    EN: require("../../assets/lang/gb.png"),
  }

  return (
    <div style={{display: "flex", alignItems: "center"}}>
      <Button
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
        style={{color: "#fff"}}
      >
        <img
          src={flagImages[language?.toUpperCase() || "EN"]}
          alt={`${language} flag`}
          style={{width: "24px", height: "16px", marginRight: "8px"}}
        />
        {language ? language : "Select Language"}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.id}
            onClick={() => handleLanguageChange(lang.code)}
          >
            <img
              src={flagImages[lang.code.toUpperCase()]}
              alt={`${lang.name} flag`}
              style={{
                width: "24px",
                height: "16px",
                marginRight: "8px",
              }}
            />
            {lang.name}
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}

export default LanguageSelector
